module.exports = __webpack_public_path__ + "static/ayampe-c978979a831f2a8c6b5750e61a618a70.png";